import { css } from '@emotion/css';

export const logoStyles = css`
  width: 7.12rem; // Since the logo width / height is 89 / 30, to prevent shrinking when width is 24
`;

type LogoSizeConfig = {
  isUserOnboardingAiEnabled?: boolean;
  isUnifiedDashboardEnabled?: boolean;
  isDefaultRestricted?: boolean;
};

type LogoSize = {
  maxWidth: string;
  height: string;
};

// Order matters: first matching condition wins.
const LOGO_SIZE_RULES: Array<{ when: (config: LogoSizeConfig) => boolean; size: LogoSize }> = [
  {
    when: (config) => Boolean(config.isUserOnboardingAiEnabled),
    size: { maxWidth: 'max-w-[19rem]', height: 'h-34' },
  },
  {
    when: (config) => Boolean(config.isUnifiedDashboardEnabled),
    size: { maxWidth: 'max-w-[13rem]', height: 'h-44' },
  },
  {
    when: (config) => Boolean(config.isDefaultRestricted),
    size: { maxWidth: 'max-w-[13rem]', height: 'h-32' },
  },
];

const DEFAULT_LOGO_SIZE: LogoSize = { maxWidth: 'max-w-[13rem]', height: 'h-24' };

export function getLogoSize(config: LogoSizeConfig): LogoSize {
  return LOGO_SIZE_RULES.find((rule) => rule.when(config))?.size ?? DEFAULT_LOGO_SIZE;
}
